import { HTTPCtmsService } from "adapters/http";
import { getTenantFromToken } from "config/helpers/common_helper";

const requireTenant = () => {
  const tenantId = getTenantFromToken();
  if (!tenantId) {
    throw new Error("Tenant not resolved");
  }
  return tenantId;
};

// Base URL is `/api/integrations` (the proxied prefix), so routes here are
// relative to the service's `/integrations` mount — i.e. just `/tenant/...`.
export const getCtmsConfig = async () => {
  const tenantId = requireTenant();
  const res = await HTTPCtmsService.get(`/tenant/${tenantId}/configuration`);
  return res.data?.data;
};

export const createCtmsConfig = async (payload) => {
  const tenantId = requireTenant();
  const res = await HTTPCtmsService.post(
    `/tenant/${tenantId}/configuration`,
    payload
  );
  return res.data?.data;
};

export const updateCtmsConfig = async (payload) => {
  const tenantId = requireTenant();
  const res = await HTTPCtmsService.put(
    `/tenant/${tenantId}/configuration`,
    payload
  );
  return res.data?.data;
};

export const pushPatientToCtms = async (patientId) => {
  const tenantId = requireTenant();
  const res = await HTTPCtmsService.post(
    `/tenant/${tenantId}/patients/${patientId}/push`
  );
  return res.data?.data ?? res.data;
};

export const pushResearchSubjectToCtms = async (researchSubjectId) => {
  const tenantId = requireTenant();
  const res = await HTTPCtmsService.post(
    `/tenant/${tenantId}/research-subjects/${researchSubjectId}/push`
  );
  return res.data?.data ?? res.data;
};
